// Copyright 2026, University of Maryland, All Rights Reserved
/**
 * Renderer identity across agents.
 *
 * Renderer ids are agent-scoped — templates carry them over unchanged, so two
 * agents can own a renderer called `analysis`. Anything that holds renderers
 * from more than one agent keys them by the ref built here, and recovers the
 * owning agent from it.
 */

/** Namespace a renderer id by its owning agent. */
export function rendererRef(agentId: string, rendererId: string): string {
  return `${agentId}::${rendererId}`
}

/**
 * The agent half of a renderer ref. Analysis results are stored per agent, so
 * anything fetching a renderer's datasets needs the agent the ref carries.
 * Returns '' for an unnamespaced id, which no dataset lookup can satisfy.
 */
export function agentFromRendererRef(ref: string): string {
  const marker = ref.indexOf('::')
  return marker < 0 ? '' : ref.slice(0, marker)
}
